import React from 'react'
import { ThemeProvider } from '@/lib/styles'

function ForgotPage() {
  return <ThemeProvider></ThemeProvider>
}

export default ForgotPage
